module.exports = __webpack_public_path__ + "static/media/MaturityLevel.81f6a172.png";